import { render } from "./SocialNetwork.vue?vue&type=template&id=7ff38332&scoped=true"
import script from "./SocialNetwork.vue?vue&type=script&lang=js"
export * from "./SocialNetwork.vue?vue&type=script&lang=js"

import "./SocialNetwork.vue?vue&type=style&index=0&id=7ff38332&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.LUMIERE+\\code\\lumiere_plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff38332"]])

export default __exports__